import I18n from '../../config/locales';
import { getPlatformBasedUrl } from '../../config/platformBasedUrls/url';
import { getCountryBasedLink } from '../../utils/helper';

export function getCountryCode(countryCode) {
  switch (countryCode) {
    case 'ES':
      return 'ES';
    case 'MX':
      return 'ES';
    case 'BR':
      return 'BR';
    case 'FR':
      return 'FR';
    case 'DE':
      return 'DE';
    case 'NL':
      return 'NL';
    case 'BE':
      return 'NL';
    case 'IT':
      return 'IT';
    default:
      return 'US';
  }
}

export function getSupportList(
  belongsToIn = false,
  belongsToMx = false,
  belongsToBr = false,
  belongsToIt = false,
  belongsToFr = false,
  belongsToUs = false,
  belongsToDe = false
) {
  const isFrInItMxBr = belongsToFr || belongsToIn || belongsToIt || belongsToMx || belongsToBr;
  return [
    {
      type: 'contact',
      name: I18n.t('dashboard.contactUs'),
      url: getCountryBasedLink('support')
    },
    belongsToUs && {
      type: 'systemConfigurator',
      name: I18n.t('dashboard.systemConfigurator'),
      url:
        'https://enphase.com/installers/systems'
    },
    belongsToUs && {
      type: 'shortcuts',
      name: I18n.t('dashboard.serviceShortcuts'),
      url:
        'https://enphase.com/en-us/service-shortcuts-for-installers?utm_source=enlighten-manager-home&utm_medium=referral'
    },
    belongsToUs && {
      type: 'newsletter',
      name: I18n.t('dashboard.newsletter'),
      url: 'https://enphase.com/en-us/installer-newsletters?utm_source=enlighten-manager-home&utm_medium=referral'
    },
    {
      type: 'service',
      name: I18n.t('dashboard.service'),
      url: getCountryBasedLink('serviceManager')
    },
    belongsToUs && {
      type: 'leads',
      name: I18n.t('dashboard.enphaseleads'),
      url: getCountryBasedLink('leads'),
      isnew: true
    },
    !belongsToDe && {
      type: 'community',
      name: I18n.t('dashboard.enphaseCommunity'),
      url: 'https://community.enphase.com/s/'
    },
    !isFrInItMxBr && {
      type: 'store',
      name: I18n.t('dashboard.enphaseStore'),
      url: getCountryBasedLink('enphaseStore')
    },
    {
      type: 'commercial',
      name: I18n.t('company.commercial'),
      url: getPlatformBasedUrl('dashboard.quickLinks.commercial'),
      isInternalLink: true
    },
    {
      type: 'critical',
      name: I18n.t('dashboard.criticalUpdates'),
      url: getCountryBasedLink('criticalUpdates'),
    },
    {
      type: 'documentation',
      name: I18n.t('dashboard.documentation'),
      url: getCountryBasedLink('documentation'),
    },
    {
      type: 'brandLibrary',
      name: I18n.t('dashboard.brandLibrary'),
      url: "https://library.enphase.com/",
    },
    {
      type: 'training',
      name: I18n.t('dashboard.training'),
      url: getCountryBasedLink('training'),
    },
    
  ];
}

export function getDistributorList(
  belongsToIn = false,
  belongsToMx = false,
  belongsToBr = false,
  belongsToIt = false,
  belongsToFr = false,
  belongsToUs = false
) {
  const isFrInItMxBr = belongsToFr || belongsToIn || belongsToIt || belongsToMx || belongsToBr;
  return [
    {
      type: 'contact',
      name: I18n.t('dashboard.contactUs'),
      url: getCountryBasedLink('support')
    },
    {
      type: 'community',
      name: I18n.t('dashboard.enphaseCommunity'),
      url: 'https://community.enphase.com/s/'
    },
    !isFrInItMxBr && {
      type: 'store',
      name: I18n.t('dashboard.enphaseStore'),
      url: getCountryBasedLink('enphaseStore')
    }
  ];
}